package dev.lingvo.shared.screenshots.frames

import dev.lingvo.shared.screenshots.color.srgbHexToOkLab
import dev.lingvo.shared.screenshots.doc.FrameFinish

/** Resolved ARGB values keep recording and browser surfaces independent of CSS colour parsing. */
data class FrameColours(val body: Long, val rim: Long, val bezel: Long)

/** Uses perceptual background lightness so AUTO contrasts consistently across saturated palettes. */
fun frameColours(finish: FrameFinish, paletteBg: String): FrameColours {
    val resolved = if (finish == FrameFinish.AUTO) {
        if (srgbHexToOkLab(if (Regex("^#[0-9a-fA-F]{8}$").matches(paletteBg)) paletteBg.take(7) else paletteBg).l > .6) FrameFinish.GRAPHITE else FrameFinish.SILVER
    } else finish
    return when (resolved) {
        FrameFinish.GRAPHITE -> FrameColours(0xFF1D1E20, 0xFF47484C, 0xFF050506)
        FrameFinish.SILVER -> FrameColours(0xFFE3E4E6, 0xFFFAFAFB, 0xFF050506)
        FrameFinish.MIDNIGHT -> FrameColours(0xFF1E2433, 0xFF3B4458, 0xFF050506)
        FrameFinish.SAND -> FrameColours(0xFFD8CBB8, 0xFFEFE6D8, 0xFF050506)
        FrameFinish.WHITE -> FrameColours(0xFFF4F4F1, 0xFFFFFFFF, 0xFF0A0A0B)
        FrameFinish.AUTO -> throw IllegalStateException("AUTO must be resolved before looking up a finish")
    }
}
